export const APP_CONFIG = {
  NAME: 'Artifact Sandbox',
  VERSION: '0.1.0',
  STORAGE_KEY: 'artifact-sandbox',
  MAX_ARTIFACT_SIZE: 10 * 1024 * 1024, // 10MB
  MAX_TOTAL_SIZE: 100 * 1024 * 1024, // 100MB
  AUTO_SAVE_DELAY: 1000, // 1 second
  SEARCH_DEBOUNCE_DELAY: 300, // 300ms
} as const;

export const STORAGE_KEYS = {
  ARTIFACTS: 'artifacts',
  UI_STATE: 'ui_state',
  SETTINGS: 'settings',
} as const;

export const FILE_TYPES = {
  HTML: '.html',
  HTM: '.htm',
} as const;

export const ACCEPTED_FILE_TYPES = [
  'text/html',
  'application/html',
  '.html',
  '.htm',
] as const;

export const ERROR_MESSAGES = {
  FILE_TOO_LARGE: 'File size exceeds the maximum limit',
  INVALID_FILE_TYPE: 'Only HTML files are supported',
  STORAGE_QUOTA_EXCEEDED: 'Storage quota exceeded. Please delete some artifacts.',
  NETWORK_ERROR: 'Network error occurred. Please try again.',
  INVALID_HTML: 'Invalid HTML content provided',
  ARTIFACT_NOT_FOUND: 'Artifact not found',
  OPERATION_FAILED: 'Operation failed. Please try again.',
} as const;

export const SUCCESS_MESSAGES = {
  ARTIFACT_CREATED: 'Artifact created successfully',
  ARTIFACT_UPDATED: 'Artifact updated successfully',
  ARTIFACT_DELETED: 'Artifact deleted successfully',
  FILE_IMPORTED: 'File imported successfully',
  DATA_EXPORTED: 'Data exported successfully',
} as const;

export const DEFAULT_HTML_TEMPLATE = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>New Artifact</title>
    <style>
        body {
            font-family: sans-serif;
            line-height: 1.6;
            margin: 0;
            padding: 2rem;
            background: #f5f5f5;
        }
        .container {
            max-width: 800px;
            margin: 0 auto;
            background: white;
            padding: 2rem;
            border-radius: 8px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }
        h1 {
            color: #333;
            border-bottom: 2px solid #007acc;
            padding-bottom: 0.5rem;
        }
    </style>
</head>
<body>
    <div class="container">
        <h1>Welcome to Artifact Sandbox</h1>
        <p>Start editing this HTML to create your artifact!</p>
    </div>
</body>
</html>`;